export { default } from './EditableTextarea';
